(function () {
  const selector = '[data-dlx-cart-link]';
  let pendingFetch;

  function badgeValue(count) {
    return count > 99 ? '99+' : String(Math.max(0, count));
  }

  function readItemCount(cart) {
    if (Number.isFinite(cart?.item_count)) return cart.item_count;

    if (Array.isArray(cart?.items)) {
      return cart.items.reduce((total, item) => total + (Number(item.quantity) || 0), 0);
    }

    return 0;
  }

  function setCount(count) {
    const normalizedCount = Math.max(0, Number(count) || 0);

    document.querySelectorAll(selector).forEach((link) => {
      const label = link.dataset.dlxCartLabel || link.getAttribute('aria-label') || 'Cart';
      const badge = link.querySelector('[data-dlx-cart-count]');

      link.classList.toggle('has-items', normalizedCount > 0);
      link.setAttribute('aria-label', `${label} (${normalizedCount})`);
      link.dataset.dlxCartItemCount = String(normalizedCount);

      if (badge) badge.textContent = badgeValue(normalizedCount);
    });
  }

  async function fetchCartCount() {
    if (pendingFetch) return pendingFetch;

    const cartUrl = window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js';

    pendingFetch = fetch(cartUrl, {
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
      },
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (cart) setCount(readItemCount(cart));
      })
      .catch(() => {})
      .finally(() => {
        pendingFetch = null;
      });

    return pendingFetch;
  }

  function watchCartUpdates() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, fetchCartCount);
      subscribe(PUB_SUB_EVENTS.quantityUpdate, fetchCartCount);
      return;
    }

    document.addEventListener('cart:updated', fetchCartCount);
  }

  function boot() {
    if (!document.querySelector(selector)) return;

    fetchCartCount();
    watchCartUpdates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
